import { render, staticRenderFns } from "./RelatedActsView.vue?vue&type=template&id=2ffd453f&scoped=true&"
import script from "./RelatedActsView.vue?vue&type=script&lang=js&"
export * from "./RelatedActsView.vue?vue&type=script&lang=js&"
import style0 from "./RelatedActsView.vue?vue&type=style&index=0&id=2ffd453f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd453f",
  null
  
)

export default component.exports